/**
 * @param {string} text
 * @returns {Promise<boolean>}
 */
export async function copyText(text) {
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) {
    /* fall through */
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch (_) {
    return false;
  }
}

/**
 * @param {{ name: string, title: string, date: string }} opts
 * @returns {Promise<string|null>} blob URL for download, or null
 */
export function buildFirstPlayerPosterPng({ name, title, date }) {
  return new Promise((resolve) => {
    try {
      const w = 1080;
      const h = 1920;
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        resolve(null);
        return;
      }
      const g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#110022');
      g.addColorStop(1, '#1a0033');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);

      ctx.strokeStyle = 'rgba(124, 58, 237, 0.5)';
      ctx.lineWidth = 4;
      ctx.strokeRect(48, 48, w - 96, h - 96);

      ctx.fillStyle = '#a78bfa';
      ctx.font = '600 36px Nunito, sans-serif';
      ctx.textAlign = 'center';
      ctx.fillText('MeepleTab', w / 2, 200);

      ctx.fillStyle = '#ffffff';
      ctx.font = '800 72px Fredoka One, Nunito, sans-serif';
      ctx.fillText('First player', w / 2, 360);

      ctx.font = '800 96px Fredoka One, Nunito, sans-serif';
      ctx.fillStyle = '#ffd700';
      const lines = wrapText(ctx, name, w - 160, 900);
      let y = 520;
      lines.forEach((line) => {
        ctx.fillText(line, w / 2, y);
        y += 110;
      });

      ctx.fillStyle = '#a78bfa';
      ctx.font = '600 40px Nunito, sans-serif';
      const tLines = wrapText(ctx, title, w - 160, 800);
      tLines.forEach((line) => {
        ctx.fillText(line, w / 2, y + 40);
        y += 56;
      });

      ctx.fillStyle = '#ffffff';
      ctx.font = '500 32px Nunito, sans-serif';
      ctx.fillText(date, w / 2, h - 200);

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            resolve(null);
            return;
          }
          resolve(URL.createObjectURL(blob));
        },
        'image/png',
        0.92
      );
    } catch (_) {
      resolve(null);
    }
  });
}

function wrapText(ctx, text, maxWidth, _maxFont) {
  const words = text.split(/\s+/);
  const lines = [];
  let line = '';
  words.forEach((word) => {
    const test = line ? `${line} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && line) {
      lines.push(line);
      line = word;
    } else {
      line = test;
    }
  });
  if (line) lines.push(line);
  return lines.length ? lines : [text];
}
